<!--
Booking summary screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav :name="bookingMessage" :back="true" :step="true" :showNotif="true" />
  <Spinner ref="spinner" />
    <div>

      <p class="summaryTitle">
        Booking Summary
      </p>
      <p class="summaryInstructions">
        Please check all information below.
        If you need to cancel you can do this on the room booking page.
      </p>

      <RoomDisplay
          :room="booking.location"
          :date="booking.bookingDate"
          :startTime="booking.startTime"
          :endTime="booking.endTime"
          :attendees="booking.attendees"
          :capacity="booking.capacity" 
          :showNoFoodDrink="true"/>
      <!--<CovidGuidelines />-->
      
<div>
    </div>
      <div style="width:100%;padding-left:24px;padding-right:24px;">
        <button :disabled="bookingDisabled" style="" class="bookingConfirm" @click=submitBooking id="submitBtn" tabindex="0">
          Confirm Booking
        </button>
      </div>
    </div>
    <hr/>
    <!-- <div class="covidContainer">
          <CovidHeader />
          </div> -->
          <br/><br/>
    <Footer active="findaspace"/>

     <NewModalPopup v-if="showErrorModal" id="error" :title="bookingError">
      <p>{{ errorMsg }}</p>
      <button class="btn btn-secondary" @click="showErrorModal = false">OK</button>
    </NewModalPopup>

    <div id="pusher"></div>
    <Footer active="booking"/>
  </div>
</template>

<script setup>
//Utilities
import axios from 'axios'
import { store } from '@/components/reactiveStore.js'
import {ref, onMounted} from 'vue'
import {useRouter} from 'vue-router'
const router = useRouter()

//Components
import RoomDisplay from '@/components/booking/RoomDisplay.vue'
import Spinner from '@/components/Spinner.vue'
// import CovidHeader from '@/components/CovidHeader.vue'
// import CovidGuidelines from '@/components/CovidGuidelines.vue'
// import ModalPopup from '@/components/ModalPopup.vue'
import NewModalPopup from '@/components/NewModalPopup.vue'
import Footer from '@/components/FooterMenu.vue'

//Composables
import {useUserMethods} from '@/composables/UserMethods.js'
const {isStudent} = useUserMethods()

//Data
let bookingMessageInit = 'Book a Room'
if (isStudent()) {
  bookingMessageInit = 'Book a Study Room'
}

const showErrorModal = ref(false)
const results = ref(true)
const bookingMessage = ref(bookingMessageInit)
const bookingDisabled = ref(false)
const bookingError = ref('Booking Error')
const errorMsg = ref('')
const booking = ref({})
const submitData = ref({})

//Component refs
const spinner = ref(null)

onMounted(
  ()=> {
    const bookingStore = store.get()
    if (bookingStore && bookingStore.location) {
      booking.value = bookingStore
    } else {
      console.error('no booking received from summary page.')
      errorMsg.value = 'The booking information did not load correctly. Please go back and select your choice again. If this error persists please tell us the details in App Support.'
      showErrorModal.value = true
    }
  }
)

function getDbFormat (d) {
  // format the date YYYY-MM-DD HH:mm
  let ret = d.getFullYear() + '-' +
    ((d.getMonth() + 1) + '').padStart(2, '0') + '-' +
    (d.getDate() + '').padStart(2, '0') + ' ' +
    (d.getHours() + '').padStart(2, '0') + ':' +
    (d.getMinutes() + '').padStart(2, '0')
  return ret
}

function createData () {

  let d = [] // 30 minute slots from this.startTime to this.endTime -- YYYY-MM-DD HH:mm
  let dte = new Date(booking.value.bookingDate + ' ' + booking.value.startTime)
  let endDate = new Date(booking.value.bookingDate + ' ' + booking.value.endTime)
  const HALF_HOUR = 1000 * 60 * 30
  const MINUTE = 1000 * 60

  while (dte < endDate) {
    let tzAdjustedDate = new Date(dte.getTime() + MINUTE * dte.getTimezoneOffset())
    d.push(getDbFormat(tzAdjustedDate))
    dte = new Date(dte.getTime() + HALF_HOUR)
  }
  console.log(booking.value.bookingDate + ' for ' + booking.value.startTime + ' - ' + booking.value.endTime)
  submitData.value.dates = d
  submitData.value.attendees = booking.value.attendees
  submitData.value.locationId = booking.value.roomid

  console.log(JSON.stringify(submitData.value))
}

function submitForm () {
  window.errorOverride = function (msg) {
    errorMsg.value = msg
    bookingError.value = 'Booking Error'
    // if clash invite them to try again?
    if (msg.indexOf('clash') != -1) {
      bookingError.value = 'Booking Clash'
      errorMsg.value = 'Sorry, but it looks like this room is now busy. Please go back to the Search Details screen and try again.'
    } else if (msg.indexOf('slot') != -1 && msg.indexOf('not valid') != -1) {
      errorMsg.value += ' Please go back to the initial booking screen and check your booking start and end times.'
    }

    // show modal
    // $('#errorModal').modal('show')
    showErrorModal.value = true
  }
  bookingDisabled.value = true
  spinner.value.spin()
  axios.post('/timetable/bookingv2', submitData.value)
    .then(response => {
      console.log(response.data)
      bookingDisabled.value = false
      router.push({
        name: 'bookingConfirmation'
      })
    })
    .catch(error => {
      console.log(error)
      bookingDisabled.value = false
      spinner.value.stop()
    })
    .finally(() => {
      // this.$refs.spinner.stop()
    })
}

function submitBooking () {
  createData()
  submitForm()
}

</script>

<style scoped>
.covidContainer {
  margin-left: 24px;
  margin-right: 24px;
}
.summaryTitle {
  color: var(--uog-dark-blue);
  font-weight:700;
  margin-left:24px;
  margin-right:24px;
  margin-top:24px;
  margin-bottom:4px;
  font-size:20px;
}

.summaryInstructions {
  margin-left:24px;
  margin-right:24px;
  margin-bottom:8px;
  font-size:18px;
}
.bookingConfirm:disabled {
  opacity: 50%
}

.bookingConfirm {
  background: var(--uog-dark-blue);
  border-radius: 12px;
  border:1px solid var(--uog-dark-blue);
  padding-top:6px;
  padding-bottom:4px;
  text-align:center;
  padding-left:8px;
  padding-right:8px;
  color:#ffffff;
  font-weight:700;
  font-size: 18px;
  height: 55px;

  width:100%;
  margin-bottom:10px;
}
</style>
